module.exports = __webpack_public_path__ + "img/mac_mobile_en.df90a610.png";